// extracted by mini-css-extract-plugin
module.exports = {"container":"vhDNX1","form":"_3-nZss"};